module.exports = __webpack_public_path__ + "static/ashardalon_s_stride-555ca642bcc3f60c3d35d7638e618cdc.png";